import {
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_SUCCEEDED,
    TOP_TAGS_FAILED,
    ACTIVITY_CALENDAR_REQUESTED,
    ACTIVITY_CALENDAR_SUCCEEDED,
    ACTIVITY_CALENDAR_FAILED,
    PIECES_COLLECTED_REQUESTED,
    PIECES_COLLECTED_SUCCEEDED,
    PIECES_COLLECTED_FAILED,
} from './constants';

export function topContributorsRequested(date, customDate) {
    return {
        type: TOP_CONTRIBUTORS_REQUESTED,
        date,
        customDate,
        contributorsLoading: true,
    };
}

export function topContributorsSucceeded(topContributors) {
    return {
        type: TOP_CONTRIBUTORS_SUCCEEDED,
        topContributors,
        contributorsLoading: false,
    };
}

export function topContributorsFailed(error) {
    return {
        type: TOP_CONTRIBUTORS_FAILED,
        error,
        contributorsLoading: false,
    };
}

export function topTagsRequested(taxonomy) {
    return {
        type: TOP_TAGS_REQUESTED,
        taxonomy,
        tagsLoading: true,
    };
}

export function topTagsSucceeded(topTags) {
    return {
        type: TOP_TAGS_SUCCEEDED,
        topTags,
        tagsLoading: false,
    };
}

export function topTagsFailed(error) {
    return {
        type: TOP_TAGS_FAILED,
        tagsLoading: false,
        error,
    };
}

export function activityRequested(year) {
    return {
        type: ACTIVITY_CALENDAR_REQUESTED,
        year,
        activityLoading: true,
    };
}

export function activitySucceeded(activityData) {
    return {
        type: ACTIVITY_CALENDAR_SUCCEEDED,
        activityData,
        activityLoading: false,
    };
}

export function activityFailed(error) {
    return {
        type: ACTIVITY_CALENDAR_FAILED,
        error,
        activityLoading: false,
    };
}

export function piecesCollectedRequested() {
    return {
        type: PIECES_COLLECTED_REQUESTED,
        piecesLoading: true,
    };
}

export function piecesCollectedSucceeded(litterCount) {
    return {
        type: PIECES_COLLECTED_SUCCEEDED,
        litterCount,
        piecesLoading: false,
    };
}

export function piecesCollectedFailed(error) {
    return {
        type: PIECES_COLLECTED_FAILED,
        error,
        piecesLoading: false,
    };
}
